import React, {Component, ReactNode} from "react"

import {FormattedMessage} from "@irati/utils/lang"

import DefaultHeader from "./DefaultHeader"

import {ExpanderArrow, ExpanderContent, HeaderWrapper} from "./styled"

type ExpanderProps = {
  Header?: ReactNode
  HeaderLabel?: ReactNode
  Arrow?: ReactNode
  above?: boolean
  fullWidth?: boolean
  showText?: string
  hideText?: string
  onChange?: (isExpanded: boolean) => void
  showArrow?: boolean
  iconSize?: number
}

interface State {
  isExpanded: boolean
}

class Expand extends Component<ExpanderProps, State> {
  static defaultProps = {
    Header: DefaultHeader,
    Arrow: ExpanderArrow,
    showText: <FormattedMessage id="platform.ui.expander.text" />,
    onChange: () => {},
    showArrow: true
  }

  state: State = {
    isExpanded: false
  }

  componentDidUpdate(_: ExpanderProps, prevState: State) {
    const {isExpanded} = this.state
    if (isExpanded !== prevState.isExpanded) {
      this.props.onChange?.(isExpanded)
    }
  }

  open = () => new Promise((resolve) => this.setState({isExpanded: true}, resolve))
  close = () => new Promise((resolve) => this.setState({isExpanded: false}, resolve))
  toggle = () => new Promise((resolve) => this.setState({isExpanded: !this.state.isExpanded}, resolve))

  container = React.createRef<HTMLSpanElement>()
  render() {
    const {Arrow, Header, HeaderLabel, fullWidth, above, children, showText, hideText = showText, showArrow, iconSize} = this.props
    const {isExpanded} = this.state

    const openContent = isExpanded ? <ExpanderContent>{children}</ExpanderContent> : null

    return (
      <span ref={this.container}>
        {above && openContent}
        <HeaderWrapper onClick={this.toggle} inline={!fullWidth} fullWidth={fullWidth}>
          <Header renderProps={{HeaderLabel, showText, hideText, isExpanded}} />
          {showArrow && <Arrow isExpanded={isExpanded} size={iconSize || 20} />}
        </HeaderWrapper>
        {!above && openContent}
      </span>
    )
  }
}

export default Expand
